(function(angular){
	'use strict';
	
	var timelineObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			acquisitionDate: '<',
			exitDate: '<',
			updates: '<'
		},
		controller: [
			'APP_BASE_PATH',
			TimelineFunction
		],
		controllerAs: 'timeline'
	};
	
	angular
		.module('viewReitElementModule')
		.component('timeline', timelineObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/reit/timeline.html';
	}
	
	function TimelineFunction(
		APP_BASE_PATH
	){
		var timeline = this;
		timeline.basePath = APP_BASE_PATH;

		timeline.$onInit = function() {

			if(timeline.acquisitionDate) {
				timeline.updates.unshift({
					displayDate: timeline.acquisitionDate,
					eventType: 'AcquisitionEvent',
					plainTimelineItem: true
				});
			}

			if(timeline.exitDate) {	
				timeline.updates.push({
					displayDate: timeline.exitDate,
					eventType: 'ExitEvent',
					plainTimelineItem: true
				});
			}
		};
	}
})(window.angular);